import React from 'react';
import { connect } from 'react-redux';
import mobileConfigActions from '../../../../../actions/mobileConfig.actions';
import * as mobileConfigApi from '../../../../../api/mobileConfig';
import ConfigSensorsPage from './ConfigSensorsPage';
import qs from 'qs';

function ConfigSensors(props) {
  const { id } = qs.parse(props.location.search, { ignoreQueryPrefix: true });
  const [mobileConfig, setMobileConfig] = React.useState(null);
  async function getMobileConfigDetail() {
    mobileConfigApi
      .getMobileConfigDetail(id)
      .then((resp) => setMobileConfig(resp))
      .catch((err) => console.log(err));
  }
  React.useEffect(() => {
    props.getSensorsByMobileConfigId(id);
    getMobileConfigDetail();
  }, []);
  async function onConfig(values) {
    await props.configSensors(id, values).then(() => props.history.goBack());
  }
  return (
    <ConfigSensorsPage
      loading={props.mobileConfig.loading}
      sensors={props.mobileConfig.sensors}
      isSubmitting={props.mobileConfig.isSubmitting}
      onConfig={onConfig}
      errors={props.mobileConfig.errors}
      mobileConfig={mobileConfig}
    />
  );
}

function mapStateToProps(state) {
  return {
    mobileConfig: state.mobileConfig,
  };
}

export default connect(mapStateToProps, mobileConfigActions)(ConfigSensors);
